module.exports = __webpack_public_path__ + "img/pvc_expodots_0015_grey.58615ec4.jpg";